import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { hydrateAuth } from '../actions'

class Bootstrap extends React.Component {
  componentDidMount () {
    this.props.hydrateAuth()
  }

  render () {
    if (this.props.authHydrated) {
      return this.props.children
    } else if (this.props.error) {
      return <div>An error has occured.</div>
    } else {
      return <div>Loading...</div>
    }
  }
}

Bootstrap.propTypes = {
  authHydrated: PropTypes.bool,
  children: PropTypes.node
}

const mapStateToProps = state => {
  return {
    authHydrated: state.auth.authHydrated,
    error: state.auth.error
  }
}

export default connect(mapStateToProps, { hydrateAuth })(Bootstrap)
